import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `licencesLoaded` / `save*` transitions).
 */

/** Load the licences for the picker (dispatched on mount). */
export const licencesRequested = createAction('addUser/licencesRequested');

/** Create the user from the current draft (dispatched on Save). */
export const submitRequested = createAction('addUser/submitRequested');
